import { render, staticRenderFns } from "./userPicker.vue?vue&type=template&id=20b99172&scoped=true&"
import script from "./userPicker.vue?vue&type=script&lang=js&"
export * from "./userPicker.vue?vue&type=script&lang=js&"
import style0 from "./userPicker.vue?vue&type=style&index=0&id=20b99172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b99172",
  null
  
)

export default component.exports